import React from 'react';
import { BaasicSelect, Loader, BaasicCheckbox, SliderCheckBox } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { channelType } from 'common/constants';
import _ from 'lodash';

const AssignCarrierServiceAndWarehouseTemplate = ({
	t,
	assignCarrierServiceAndWarehouseViewStore: {
		loading,
		form,
		carrierServiceOptions,
		warehouseOptions,
		onCarrierServiceSelect,
		onWarehouseSelect,
		onBack,
		onCheck,
		useBuyShipping,
		handleOnWarehouseMenuScroll,
		handleOnServiceCarrierMenuScroll,
		debouncedWarehouseSearch,
		debouncedCarrierServiceSearch,
		isCarrierServiceLoading,
		onMenuClose,
		isWarehouseDropdownLoading,
		selectedItem,
		selectedItems,
		isBulkAction,
		isAllAmazon,
		onIgnoreDeliverByDateChange,
		isSuperAdminOrganization,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.ASSIGNMODAL.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<BaasicSelect
						field={form.$('assignedWarehouse')}
						clearable={false}
						options={warehouseOptions.slice()}
						onChange={onWarehouseSelect}
						value={form.$('assignedWarehouse').value}
						onMenuScrollToBottom={handleOnWarehouseMenuScroll}
						onMenuClose={onMenuClose}
						onInputChange={debouncedWarehouseSearch}
						isLoading={isWarehouseDropdownLoading}
						className="spc--bottom--sml flex--grow--1"
					/>
					<BaasicSelect
						field={form.$('assignedCarrierService')}
						isLoading={isCarrierServiceLoading}
						options={carrierServiceOptions.slice()}
						onChange={onCarrierServiceSelect}
						value={form.$('assignedCarrierService').value}
						onInputChange={debouncedCarrierServiceSearch}
						onMenuScrollToBottom={handleOnServiceCarrierMenuScroll}
						className="spc--bottom--sml flex--grow--1"
						isClearable={isBulkAction}
						useCustomOption={true}
					/>

					{!isSuperAdminOrganization &&
						selectedItem != null &&
						selectedItems == null &&
						selectedItem.order.channel.channelType.name === channelType.amazon && (
							<div className="spc--bottom--sml">
								<BaasicCheckbox
									id={form.$('useBuyShipping').id}
									onChange={onCheck}
									label="FULFILLMENTORDER.ASSIGNMODAL.USEBUYSHIPPING"
									checked={form.$('useBuyShipping').value}
								/>
							</div>
						)}

					{isBulkAction && isAllAmazon && !isSuperAdminOrganization && (
						<div className="spc--bottom--sml">
							<BaasicCheckbox
								id={form.$('useBuyShipping').id}
								onChange={onCheck}
								label={'FULFILLMENTORDER.ASSIGNMODAL.USEBUYSHIPPING'}
								checked={useBuyShipping}
								disabled={!isAllAmazon}
							/>
						</div>
					)}

					{isSuperAdminOrganization && (
						<div className="flex--primary spc--bottom--sml">
							<div className="spc--right--xsml">
								<SliderCheckBox field={form.$('ignoreDeliverByDate')} onValueChange={onIgnoreDeliverByDateChange} />
							</div>
							<div>
								<label className="type--wgt--bold type--color--text">
									{t('FULFILLMENTORDER.ASSIGNMODAL.IGNOREDELIVERBYDATE')}
								</label>
								{((selectedItem != null && selectedItem.order.channel.channelType.name === channelType.amazon) ||
									(selectedItems != null &&
										selectedItems.some(item => item.order.channel.channelType.name === channelType.amazon))) && (
									<span className="display--b type--color--grey-5">
										{t('FULFILLMENTORDER.ASSIGNMODAL.IGNOREDELIVERBYDATEFORAMAZON')}
									</span>
								)}
							</div>
						</div>
					)}

					{isBulkAction && !isAllAmazon && !isSuperAdminOrganization && (
						<div className="spc--bottom--sml">{t('BUYSHIPPINGOPTIONDISABLED')}</div>
					)}
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
						type="submit"
						disabled={
							form.$('assignedCarrierService').value === '' ||
							form.$('assignedCarrierService').value === null ||
							form.$('assignedWarehouse').value === '' ||
							form.$('assignedWarehouse').value === null ||
							form.submitting
						}
					>
						{t('SAVE')}
					</button>
					<button className="btn btn--med btn--secondary spc--bottom--sml" type="button" onClick={onBack}>
						{t('BACK')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(AssignCarrierServiceAndWarehouseTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/AssignCarrierServiceAndWarehouseTemplate.jsx